/* eslint-disable no-unused-vars */
import axios from "axios";
import { Get } from "../Request";
import { TIMEZONE_ITEMS } from "../../utils/timezones";

export default {
  state: {
    countries: [],
    AllTimeZone: TIMEZONE_ITEMS,
  },
  getters: {
    GetCountry(state) {
      return state.countries;
    },
    GetTimeZone(state) {
      return state.AllTimeZone;
    },
  },
  actions: {
    GetAllCountries({ commit }, payload) {
      axios.get("https://restcountries.com/v3.1/all").then((res) => {
        commit("SetCountry", res);
      });
    },
  },
  mutations: {
    SetCountry(state, payload) {
      state.countries = payload.data.map((x) => x.name.common);
    },
  },
};
